import { ReactNode } from 'react'
import { Accordion as RadixAccordion } from 'radix-ui'
import { ChevronUp } from '@components/icons'
import * as Sentry from '@sentry/nextjs'

export const Accordion = ({
  sections,
}: {
  sections: {
    id: string
    title: string
    children: ReactNode[]
  }[]
}) => {
  if (!sections) {
    Sentry.captureMessage('Render Error. Accordion is missing sections.')
    return null
  }

  return (
    <div className="w-full flex flex-col border-pebble border-b-2">
      <RadixAccordion.Root
        type="single"
        defaultValue={sections[0].id}
        collapsible
      >
        {sections?.map((x) => {
          if (!x?.title || !x?.id || !x?.children) {
            Sentry.captureMessage(
              'Render Error. Accordion section is missing title, id, or components.'
            )
            return null
          }

          return (
            <RadixAccordion.Item value={x.id} className="overflow-hidden">
              <RadixAccordion.Trigger className="relative group bg-white flex justify-between items-center py-6 w-full border-t-2 border-pebble z-10">
                <h5 className="text-[20px] leading-[26px] font-semibold text-acai font-mori text-left select-none">
                  {x.title}
                </h5>
                <ChevronUp
                  aria-hidden
                  className={`text-4xl text-acai transition-all duration-[500ms] ease-in-out group-data-[state=open]:rotate-x-0 group-data-[state=closed]:rotate-x-180`}
                />
              </RadixAccordion.Trigger>

              <RadixAccordion.Content className="relative data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown z-5">
                <div className="py-12 w-full border-t-2 border-pebble select-none">
                  {x.children}
                </div>
              </RadixAccordion.Content>
            </RadixAccordion.Item>
          )
        })}
      </RadixAccordion.Root>
    </div>
  )
}
